'use strict';

const { hydrate } = require('@grpn/hydration');

const Card = require('./card');

module.exports = hydrate('Card', Card);
